import i18next from 'i18next';
import { LeasingType } from 'modules/types/LeasingOffer';

export enum ContractsDetailsSection {
  DETAILS,
  REPAYMENT_PLAN,
  FACILITY_INFORMATION,
}

export const getContractDataLabel = (key: string, contractData: any) => {
  if (key === 'remainingValueEur') {
    const contractLeasingType = contractData.leasingTypeCategory?.toLowerCase();

    if (contractLeasingType?.includes(LeasingType.FINANCIAL.toLowerCase())) {
      return i18next.t(`contractOverview.data.financialRemainingValue`);
    }
    if (contractLeasingType?.includes(LeasingType.OPERATIONAL.toLowerCase())) {
      return i18next.t(`contractOverview.data.operationalRemainingValue`);
    }
  }

  return i18next.t(`contractOverview.data.${key}`);
};

export const getContractDataTooltipLabel = (key: string, contractData: any) => {
  const contractLeasingType = contractData.leasingTypeCategory?.toLowerCase();

  if (key === 'purchaseValueEur') {
    if (contractLeasingType?.includes(LeasingType.FINANCIAL.toLowerCase())) {
      return i18next.t(`contractOverview.data.purchaseValueFinancialLeasing`);
    }
    if (contractLeasingType?.includes(LeasingType.OPERATIONAL.toLowerCase())) {
      return i18next.t(`contractOverview.data.purchaseValueOperationalLeasing`);
    }
  } else if (key === 'remainingValueEur') {
    if (contractLeasingType?.includes(LeasingType.OPERATIONAL.toLowerCase())) {
      return i18next.t(`contractOverview.data.remainingValueEurTooltip`);
    }
  }

  return null;
};

export const skipInfoRow = (key: string, contractData: any) => {
  if (key === 'bailAmountEur') {
    const contractLeasingType = contractData.leasingTypeCategory?.toLowerCase();

    if (contractLeasingType?.includes(LeasingType.FINANCIAL.toLowerCase())) {
      return true;
    }
  }
  return false;
};
